import {Button, Form, Input, InputNumber, Popconfirm, Select, Table} from 'antd'
import React, {useContext, useEffect, useImperativeHandle, useRef, useState} from 'react'
import {DeleteOutlined, PlusCircleOutlined, SearchOutlined} from '@ant-design/icons'
import {getDataType, getJavaDataType} from '../../../utils'
import {withTranslation} from 'react-i18next'

const EditableContext = React.createContext(null)
const EditableRow = ({index, ...props}) => {
  const [form] = Form.useForm()
  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  )
}

const FieldSetForm = (props) => {
  const [dataSource, setDataSource] = useState([])
  const [count, setCount] = useState(0)
  const {value, onChange, sampleData, onRef, t} = props
  const [isRetainKeyShow, setIsRetainKeyShow] = useState(false)

  const [searchVal, setSearchVal] = useState('')
  useImperativeHandle(onRef, () => ({
    init,
  }))

  const EditableCell = ({value, title, editable, children, dataIndex, record, handleSave, ...restProps}) => {
    const inputRef = useRef(null)
    const form = useContext(EditableContext)
    useEffect(() => {
    }, [])

    const fieldTypeList = [
      {value: 'BOOLEAN', label: 'Boolean'},
      {value: 'NUMBER', label: 'Number'},
      {value: 'STRING', label: 'String'},
      {value: 'STRUCT', label: 'Struct'},
      {value: 'ARRAY', label: 'Array'},
      {value: 'DATESTRING', label: 'Date'}
    ]
    const arrayTypeList = fieldTypeList.filter(item => item.value !== 'ARRAY')
    const requiredList = [
      {value: '1', label: 'true'},
      {value: '2', label: 'false'}
    ]

    const changeType = async () => {
      const values = await form.validateFields()
      if ((values.fieldType === 'ARRAY' && values.arrayType === 'STRUCT') || values.fieldType === 'STRUCT') {
        record.children = record.children || []
      } else {
        record.children = null
      }
      if (values.fieldType !== 'ARRAY') {
        record.arrayType = null
      }
      if (values.fieldType !== 'DATESTRING') {
        record.format = null
      }
      if (values.fieldType !== 'STRING') {
        record.length = null
      }
      if (values.fieldType === 'ARRAY' && dataSource.length === 1) {
        setIsRetainKeyShow(true)
      } else {
        setIsRetainKeyShow(false)
      }
      await save()
    }

    const save = async () => {
      try {
        const values = await form.validateFields()
        let rowData = {...record, ...values}
        // toggleEdit();
        handleSave(rowData)
      } catch (errInfo) {
        console.log('Save failed:', errInfo)
      }
    }

    let childNode = children

    if (editable) {
      if (dataIndex === 'name') {
        childNode = (
          <Form.Item style={{margin: 0,}} name={dataIndex} initialValue={record.name ? record.name : ''}>
            <Input ref={inputRef} onPressEnter={save} onBlur={save}/>
          </Form.Item>
        )
      } else if (dataIndex === 'path') {
        childNode = (
          <Form.Item style={{margin: 0,}} name={dataIndex} initialValue={record.path ? record.path : ''}>
            <Input ref={inputRef} onPressEnter={save} onBlur={save}/>
          </Form.Item>
        )
      } else if (dataIndex === 'fieldType') {
        childNode = (
          <Form.Item style={{margin: 0,}} name={dataIndex} initialValue={record.fieldType ? record.fieldType : ''}>
            <Select
              placeholder={t(`apiManagement.selectFieldType`)}
              onSelect={() => changeType(record)}
            >
              {fieldTypeList.length > 0 ? fieldTypeList.map(item => <Select.Option key={item.value}
                                                                                   value={item.value}>{item.label}</Select.Option>) : null}
            </Select>
          </Form.Item>
        )
      } else if (dataIndex === 'arrayType') {
        childNode = (
          <Form.Item style={{margin: 0,}} name={dataIndex} initialValue={record.arrayType ? record.arrayType : ''}>
            <Select
              placeholder={t(`apiManagement.selectArrayType`)}
              onSelect={() => changeType(record)}
              disabled={record.fieldType !== 'ARRAY'}
            >
              {arrayTypeList.length > 0 ? arrayTypeList.map(item => <Select.Option key={item.value}
                                                                                   value={item.value}>{item.label}</Select.Option>) : null}
            </Select>
          </Form.Item>
        )
      } else if (dataIndex === 'length') {
        childNode = (
          <Form.Item style={{margin: 0,}} name={dataIndex} initialValue={record.length ? record.length : ''}>
            <InputNumber disabled={record.fieldType !== 'STRING'} min={1} onPressEnter={save} onBlur={save}/>
          </Form.Item>
        )
      } else if (dataIndex === 'format') {
        childNode = (
          <Form.Item style={{margin: 0,}} name={dataIndex} initialValue={record.format ? record.format : ''}>
            <Input disabled={record.fieldType !== 'DATESTRING'} ref={inputRef} onPressEnter={save} onBlur={save}/>
          </Form.Item>
        )
      } else if (dataIndex === 'required') {
        childNode = (
          <Form.Item style={{margin: 0,}} name={dataIndex} initialValue={record.required ? record.required : '2'}>
            <Select
              placeholder={t(`apiManagement.selectRequired`)}
              onSelect={save}
            >
              {requiredList.length > 0 ? requiredList.map(item => <Select.Option key={item.value}
                                                                                 value={item.value}>{item.label}</Select.Option>) : null}
            </Select>
          </Form.Item>
        )
      } else if (dataIndex === 'retainKey') {
        childNode = (
          <Form.Item style={{margin: 0,}} name={dataIndex} initialValue={record.retainKey}>
            <Select
              placeholder={t(`apiManagement.selectRetainKey`)}
              onChange={save}
            >
              <Select.Option key={true} value={true}>true</Select.Option>
              <Select.Option key={false} value={false}>false</Select.Option>
            </Select>
          </Form.Item>
        )

      } else if (dataIndex === 'desciption') {
        childNode = (
          <Form.Item style={{margin: 0,}} name="desciption" initialValue={record.remark ? record.remark : ''}>
            <Input ref={inputRef} onPressEnter={save} onBlur={save}/>
          </Form.Item>
        )
      }
    }

    return <td {...restProps}>{childNode}</td>
  }

  useEffect(() => {

    if (value.length) {
      let source = addRowKey(value)
      setDataSource([...source])
    } else {
      if (sampleData) {
        setTimeout(() => {
          if (dataSource.length < 1) {
            handleProcess()
          }
        }, 100)
      }
    }

    if (value.length === 1 && value[0].fieldType === 'ARRAY') {
      setIsRetainKeyShow(true)
    }

  }, ['sampleData', 'value'])

  const init = () => {
    if (dataSource.length < 1) {
      handleProcess()
    }
  }

  const customRow = (record) => {
    return searchVal && !record.name.toUpperCase().includes(searchVal.toUpperCase()) ? {
      style: {
        'display': 'none'
      }
    } : {}
  }
  const rowKey = (item) => {
    return item.index
  }
  const addRowKey = (list, level = '') => {
    if (!list) {
      return null
    }
    const newList = []
    list.forEach((item, i) => {
      const index = level ? `${level}-${i + 1}` : `${i + 1}`
      const newItem = {
        ...item,
        index: index,
        required: item.required || '2',
        remark: item.remark,
        children: addRowKey(item.children, index)
      }
      newList.push(newItem)
    })
    return newList
  }
  const handleAdd = (item) => {
    const newData = {
      // key: item.children.length,
      // index: item.children.length + 1,
      key: count,
      index: count + 1,
      format: '',
      length: '',
      name: '',
      required: '',
      remark: '',
      path: '',
      children: null
    }

    if (item && item.children) {
      // console.log(111, newData)
      item.children.push(newData)
    } else {
      let data = dataSource
      data.push(newData)
      setDataSource(data)
    }
    setDataSource(addRowKey(dataSource))
    // this.change()
    onChange(dataSource)
    setCount(count + 1)

    if (dataSource.length === 1 && dataSource[0].fieldType === 'ARRAY') {
      setIsRetainKeyShow(true)
    } else {
      setIsRetainKeyShow(false)
    }
  }

  // 清空 dataSource 全部数据
  const clearAll = () => {
    setDataSource([])
    onChange([])
    // this.change()
  }

  const jsonToTree = (data, path) => {
    const type = getDataType(data)
    const arr = []
    if (type === 'array') {
      return jsonToTree(data[0], path)
    } else if (type === 'object') {
      Object.keys(data).forEach(key => {
        const newPath = path ? path + '.' + key : key
        arr.push({
          name: key,
          path: newPath,
          ...getJavaDataType(data[key]),
          children: jsonToTree(data[key], newPath)
        })
      })
      return arr
    }
    return null
  }
  // 点击 Process 获取事件
  const handleProcess = () => {
    try {
      const dataSource = jsonToTree(JSON.parse(sampleData)) || null
      setDataSource(addRowKey(dataSource))
      onChange(addRowKey(dataSource))

      if (dataSource.length === 1 && dataSource[0].fieldType === 'ARRAY') {
        setIsRetainKeyShow(true)
      } else {
        setIsRetainKeyShow(false)
      }
    } catch (e) {
      console.log(e)
    }
  }

  const getTreeParent = (treeList, findItem, keyword) => {
    let curItem = null
    const someItem = (list, parentItem) => {
      list && list.some(item => {
        if (item[keyword] === findItem[keyword]) {
          curItem = parentItem
        } else if (item.children) {
          someItem(item.children, item)
        }
        if (curItem) {
          return true
        }
      })
    }
    someItem(treeList, null)
    return curItem
  }

  const handleDelete = (record, key) => {
    // const data = JSON.parse(JSON.stringify(dataSource))
    const parentItem = getTreeParent(dataSource, record, 'index')
    if (parentItem) {
      dataSource.forEach(item => {
        if (item.index === parentItem.index) {
          item.children.splice(key, 1)
        }
      })
    } else {
      dataSource.splice(key, 1)
    }
    // dataSource.children = [...addRowKey(dataSource.children)]
    setDataSource([...dataSource])
    onChange(dataSource)

    if (dataSource.length === 1 && dataSource[0].fieldType === 'ARRAY') {
      setIsRetainKeyShow(true)
    } else {
      setIsRetainKeyShow(false)
    }
  }

  const defaultColumns = [
    {
      title: t(`apiManagement.no`),
      width: '9%',
      dataIndex: 'index',
      isShow: true
    },
    {
      title: t(`apiManagement.name`),
      dataIndex: 'name',
      width: '9%',
      editable: true,
      isShow: true
    },
    {
      title: t(`apiManagement.path`),
      dataIndex: 'path',
      width: '9%',
      editable: true,
      isShow: true
    },
    {
      title: t(`apiManagement.type`),
      dataIndex: 'fieldType',
      width: '9%',
      editable: true,
      isShow: true
    },
    {
      title: t(`apiManagement.arrayType`),
      dataIndex: 'arrayType',
      width: '9%',
      editable: true,
      isShow: true
    },
    {
      title: t(`apiManagement.length`),
      dataIndex: 'length',
      width: '9%',
      editable: true,
      isShow: true
    },
    {
      title: t(`apiManagement.dateFormat`),
      dataIndex: 'format',
      width: '9%',
      editable: true,
      isShow: true
    },
    {
      title: t(`apiManagement.required`),
      dataIndex: 'required',
      width: '9%',
      editable: true,
      isShow: true
    },
    {
      title: t(`apiManagement.retainKey`),
      dataIndex: 'retainKey',
      width: '9%',
      editable: true,
      isShow: isRetainKeyShow
    },
    {
      title: t(`apiManagement.description`),
      dataIndex: 'desciption',
      width: '9%',
      editable: true,
      isShow: true
    },
    {
      title: t(`general.action`),
      dataIndex: 'action',
      align: 'center',
      isShow: true,
      render: (_, record, index) =>
        dataSource.length >= 1 ? (
          <>
            {record.fieldType === 'ARRAY' || record.fieldType === 'STRUCT' ? (
              <a style={{marginRight: 16}}><PlusCircleOutlined onClick={() => handleAdd(record)}/></a>) : null}
            <Popconfirm title={t(`general.sureToDelete`)} onConfirm={() => handleDelete(record, index)}>
              <a><DeleteOutlined/></a>
            </Popconfirm>
          </>
        ) : null,
    },
  ]


  const onSearchChange = (e) => {
    setSearchVal(e.target.value)
  }

  const getObj = (arr, row) => {
    // let newData = [...detail.children];
    arr.forEach(function (item, index) {
      if (item.index === row.index) {
        arr.splice(index, 1, {...item, ...row})
      } else if (item.children && item.children.length > 0) {
        getObj(item.children, row)
      }
    })
    return arr
  }
  const handleSave = (row) => {
    if (row.arrayType === '') {
      delete row.arrayType
    }
    if (row.fieldType === '') {
      delete row.fieldType
    }
    let newData = getObj(dataSource, row)
    onChange(addRowKey(newData))
    setDataSource(addRowKey(newData))
  }

  const components = {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  }
  const column = defaultColumns.map((col) => {
    if (!col.editable) {
      return col
    }

    return {
      ...col,
      onCell: (record) => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave,
      }),
    }
  })

  for (let i = 0; i < column.length; i++) {
    if (column[i].isShow === false) {
      column.splice(i, 1)
    }
  }

  return (
    <div>
      <Input placeholder={t(`apiManagement.searchName`)} suffix={<SearchOutlined/>} style={{width: 200, marginRight: 16,}} onChange={onSearchChange}/>
      <Button onClick={handleAdd} type="primary" style={{marginBottom: 16, marginRight: 16,}}>{t(`general.add`)}</Button>
      <Button onClick={handleProcess} style={{marginBottom: 16, marginRight: 16,}}>{t(`general.process`)}</Button>
      <Button onClick={clearAll} style={{marginBottom: 16, marginRight: 16,}}>{t(`general.clear`)}</Button>
      <Table
        scroll={{y: 500}}
        components={components}
        pagination={false}
        rowKey={rowKey}
        dataSource={dataSource}
        columns={column}
        onRow={customRow}
      />
    </div>
  )
}

export default withTranslation()(FieldSetForm)
